// extracted by mini-css-extract-plugin
module.exports = {"rightDivision":"LandingPage-module--rightDivision--VFY82"};